import { Provider, inject } from '@angular/core';
import { RuntimeConfigService } from '@app/service/runtime-config.service';
import { DatadogService, buildDatadogConfig, DATADOG_CONFIG_TOKEN } from '@cudirect/shared-ui-library';

export const provideDatadog = (): Provider[] => [
  {
    provide: DATADOG_CONFIG_TOKEN,
    useFactory: (appConfig: RuntimeConfigService) => {
      const config = appConfig.getConfig;
      return buildDatadogConfig(config?.dataDog);
    },
    deps: [RuntimeConfigService]
  },
  {
    provide: DatadogService,
    useFactory: () => {
      const config = inject(DATADOG_CONFIG_TOKEN);
      const datadog = new DatadogService();
      datadog.init(buildDatadogConfig(config));
      return datadog;
    },
    deps: [DATADOG_CONFIG_TOKEN]
  }
];
